import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const LEGAL = {
  kvkk: {
    title: "KVKK Aydınlatma Metni",
    intro: "SeraPark olarak kişisel verilerinizin güvenliği bizim için önceliklidir.",
    body: [
      "6698 sayılı Kişisel Verilerin Korunması Kanunu ('KVKK') kapsamında, web sitemiz aracılığıyla iletmiş olduğunuz kişisel verileriniz; yalnızca teklif değerlendirme ve iletişim taleplerinize yanıt verme amacıyla işlenmektedir.",
      "Kişisel verileriniz; yalnızca yetkili SeraPark personeli ile paylaşılır; hiçbir üçüncü tarafa ticari amaçla aktarılmaz.",
      "KVKK'nın 11. maddesi çerçevesinde; verilerinize erişme, düzeltme, silme veya işlenmesine itiraz etme haklarına sahipsiniz. Bu haklarınızı kullanmak için seraparkyapi@gmail.com adresine yazılı başvuruda bulunabilirsiniz.",
    ],
  },
  gizlilik: {
    title: "Gizlilik Politikası",
    intro: "Web sitemizde topladığımız veriler ve nasıl kullanıldıkları.",
    body: [
      "Formlar aracılığıyla ilettiğiniz ad, e-posta, telefon ve mesaj bilgileri; talebinize yanıt vermek üzere sistemimizde saklanır.",
      "Google Analytics gibi analiz araçları anonim ziyaret istatistikleri toplayabilir. Bu bilgiler kişisel olarak tanımlanmaz.",
      "Verileriniz sunucularımızda şifreli olarak barındırılır; endüstri standartlarının üzerinde bir güvenlik protokolüyle korunur.",
    ],
  },
  cerez: {
    title: "Çerez Politikası",
    intro: "Sitemiz deneyiminizi geliştirmek amacıyla çerezler kullanır.",
    body: [
      "Zorunlu çerezler: Site işlevselliği için gerekli olan çerezlerdir; kapatılmaları site kullanımını etkiler.",
      "Analitik çerezler: Ziyaret alışkanlıklarını anonim olarak analiz eder; site performansını iyileştirmemize yardımcı olur.",
      "Pazarlama çerezleri: Kullanmıyoruz. SeraPark, üçüncü taraf reklam ağlarıyla veri paylaşmaz.",
      "Tarayıcı ayarlarınızdan çerezleri istediğiniz zaman devre dışı bırakabilirsiniz.",
    ],
  },
};

export default function Legal() {
  const { pathname } = useLocation();
  const type = pathname.replace("/", "") || "kvkk";
  const doc = LEGAL[type] || LEGAL.kvkk;
  return (
    <div data-testid={`legal-${type}`} className="pt-32 pb-24 bg-[#FAFAFA]">
      <div className="max-w-[900px] mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-2 text-[11px] tracking-widest uppercase text-[#888] mb-8">
          <Link to="/" className="hover:text-[#B8860B]">Ana Sayfa</Link>
          <ChevronRight size={12} />
          <span className="text-[#1E1E1E]">{doc.title}</span>
        </div>
        <h1 className="font-serif-display text-4xl md:text-5xl text-[#1E1E1E] leading-tight">
          {doc.title}
        </h1>
        <p className="mt-4 text-[15px] text-[#666]">{doc.intro}</p>
        <div className="mt-10 space-y-6 text-[15px] text-[#444] leading-[1.9]">
          {doc.body.map((p, i) => <p key={i}>{p}</p>)}
        </div>
      </div>
    </div>
  );
}
